import {CircularProgress} from '@mui/material'
import DataRefetchOnError from '../../common/DataFetchError/DataRefetchOnError'
import MultiSelectDropdownComponent from '../../common/MulitSelectDropdown/MultiSelectDropdownComponent'
import {DropdownLoadingBox} from '../Jurisdiction/JurisdictionStyle'
import {SharedSubTitle} from '../../common/SharedSubTitleStyle'
import loadingTitles from '../../../appConfig/loadingTitles.config.json'
import PropTypes from 'prop-types'
import {StyledSectionTitle} from '../../AdminPanelStyling'
import {useProjectDetails} from '../../../store/hooks/projectDetails'
import {useFilterConfig} from '../../../store/hooks/config'

const ResourceAccessBarriersComponent = ({
  selectedData,
  setFilterValue,
  handleOptionDeletion,
  enabled,
  isCompleted,
  showCustomLabels,
  setCustomLabelDialogProps,
  hasAnyFilters
}) => {
  const {filterDetailsLoading, filterDetailsError, refetchFilterDetailsList} = useProjectDetails()
  const filterConfig = useFilterConfig()

  function refetchHealthAndConditions(event) {
    event.preventDefault()
    refetchFilterDetailsList()
  }

  const renderDropdown = () => {
    if (filterDetailsLoading) {
      return (
        <DropdownLoadingBox>
          <CircularProgress title={loadingTitles.resourceAccessBreadcrumb} />
        </DropdownLoadingBox>
      )
    }

    if (!filterDetailsLoading && filterDetailsError) {
      return <DataRefetchOnError onTryAgain={(event) => refetchHealthAndConditions(event)} />
    }

    const resourceAccessBarriersSection = filterConfig?.data?.find((section) => section.id === '5')
    const resourceAccessBarriersKeys = resourceAccessBarriersSection?.filters?.map((filter) => filter.key) || []
    const resourceAccessBarriersFilters =
      resourceAccessBarriersSection?.filters.map((filter) => ({
        title: filter.name,
        FILTER_KEY: filter.key,
        FILTER_ID: filter.key,
        IS_ACTIVE: true
      })) || []

    const sortedHealthCondition = resourceAccessBarriersFilters.sort((a, b) => {
      if (a.title < b.title) return -1
      if (a.title > b.title) return 1
      return 0
    })

    // Predicate to check if filter belongs to Resource Access Barriers section
    const isResourceAccessBarriersFilter = (filter) =>
      resourceAccessBarriersKeys.some((key) => filter.FILTER_KEY?.startsWith(key))

    // Filter selectedData to only include Resource Access Barriers filters
    const selectedResourceAccessBarriersFilters = selectedData?.filter(isResourceAccessBarriersFilter) || []

    // Wrapper to merge with other filter sections
    const handleResourceAccessBarriersChange = (newFilters) => {
      const otherFilters = selectedData?.filter((filter) => !isResourceAccessBarriersFilter(filter)) || []
      setFilterValue([...otherFilters, ...newFilters])
    }

    return (
      <MultiSelectDropdownComponent
        selectAllTitle='Select All'
        dropDownTitle='Select'
        inputAndPreviewTitle='Resource Access Barriers and Support'
        dropDownModifiedTitle='Selected'
        dropDownData={sortedHealthCondition}
        val={selectedResourceAccessBarriersFilters}
        setVal={handleResourceAccessBarriersChange}
        enabled={enabled}
        isCompleted={isCompleted}
        handleOptionDeletion={(type, data, option) => handleOptionDeletion(type, data, option)}
        hasAnyFilters={hasAnyFilters}
        isFilterDropdown={true}
        setCustomLabelDialogProps={setCustomLabelDialogProps}
        showCustomLabels={showCustomLabels}
        section='Resource Access Barriers and Support'
      />
    )
  }
  return (
    <>
      <StyledSectionTitle variant='h5'>
        {' '}
        What Resource Access Barriers and Support filters do you want available?{' '}
      </StyledSectionTitle>
      <SharedSubTitle>This is what your client will see when interacting with data on their dashboard</SharedSubTitle>
      {renderDropdown()}
    </>
  )
}

ResourceAccessBarriersComponent.propTypes = {
  selectedData: PropTypes.array.isRequired,
  setFilterValue: PropTypes.func.isRequired,
  handleOptionDeletion: PropTypes.func,
  enabled: PropTypes.bool.isRequired,
  isCompleted: PropTypes.bool.isRequired,
  showCustomLabels: PropTypes.bool,
  setCustomLabelDialogProps: PropTypes.func,
  hasAnyFilters: PropTypes.bool
}

export default ResourceAccessBarriersComponent
